var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateAudioPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 18.1814V9.81869C11.0835 9.71406 11.1119 9.6114 11.1653 9.52147C11.2188 9.43155 11.2955 9.35766 11.3874 9.30756C11.4792 9.25745 11.5829 9.23298 11.6874 9.2367C11.792 9.24042 11.8936 9.27219 11.9817 9.32869L18.487 13.5089C18.5694 13.5616 18.6372 13.6343 18.6841 13.7201C18.7311 13.8059 18.7557 13.9022 18.7557 14C18.7557 14.0979 18.7311 14.1941 18.6841 14.2799C18.6372 14.3658 18.5694 14.4384 18.487 14.4912L11.9817 18.6725C11.8936 18.729 11.792 18.7608 11.6874 18.7645C11.5829 18.7682 11.4792 18.7438 11.3874 18.6937C11.2955 18.6436 11.2188 18.5697 11.1653 18.4797C11.1119 18.3898 11.0835 18.2872 11.0834 18.1825V18.1814Z",
    fill: "url(#paint0_linear_4421_522)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 14.0003C1.16663 6.91283 6.91246 1.16699 14 1.16699C21.0875 1.16699 26.8333 6.91283 26.8333 14.0003C26.8333 21.0878 21.0875 26.8337 14 26.8337C6.91246 26.8337 1.16663 21.0878 1.16663 14.0003ZM14 2.91699C11.0605 2.91699 8.24139 4.0847 6.16286 6.16323C4.08433 8.24175 2.91663 11.0608 2.91663 14.0003C2.91663 16.9398 4.08433 19.7589 6.16286 21.8374C8.24139 23.916 11.0605 25.0837 14 25.0837C16.9394 25.0837 19.7585 23.916 21.8371 21.8374C23.9156 19.7589 25.0833 16.9398 25.0833 14.0003C25.0833 11.0608 23.9156 8.24175 21.8371 6.16323C19.7585 4.0847 16.9394 2.91699 14 2.91699Z",
    fill: "url(#paint1_linear_4421_522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4421_522",
    x1: 16.7764,
    y1: 23.8695,
    x2: 8.5721,
    y2: 21.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4421_522",
    x1: 20.2118,
    y1: 40.5837,
    x2: -5.95091,
    y2: 30.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAudioPause);
export default __webpack_public_path__ + "static/media/corporateAudioPause.bfd8d3cb5d415180865db894e0be6286.svg";
export { ForwardRef as ReactComponent };